module.exports = __webpack_public_path__ + "static/media/google-play.2d6b4c36.svg";